import { useEffect, useState } from "react";
const useImageLoader = (blob)=>{
    const [imageUrl, setImageUrl] = useState(null);
    const [imageSize, setImageSize] = useState({
        width: 0,
        height: 0
    });
    useEffect(()=>{
        if (!blob) return;
        const reader = new FileReader();
        reader.readAsText(blob);
        reader.onload = ()=>{
            try {
                const data = JSON.parse(reader.result);
                setImageUrl(data.url);
                const img = new Image();
                img.onload = ()=>{
                    setImageSize({
                        width: img.naturalWidth,
                        height: img.naturalHeight
                    });
                };
                img.src = data.url;
            } catch (error) {}
        };
        reader.onerror = ()=>{};
        return ()=>{
            reader.abort();
        };
    }, [
        blob
    ]);
    return {
        imageUrl,
        imageSize
    };
};
export { useImageLoader };
